import { tokenize } from "linkifyjs";
import { createElement } from "react";
import { blockContentStyles } from "../../components/BlockContent/blockContent.css.js";

const getLinks = (input, { linkClassName = blockContentStyles.link }) => {
  const tokens = tokenize(input);
  return tokens.map((t, index) =>
    t.t === "url" ? (
      <a
        key={index}
        className={linkClassName}
        href={t.tk[0].t === "PROTOCOL" ? t.v : `https://${t.v}`}
        target="_blank"
        rel="noreferrer"
      >
        {t.v}
      </a>
    ) : (
      t.v
    ),
  );
};

const TextWithNewlines = ({
  children,
  as = "div",
  noLinkDetection,
  linkClassName,
  ...rest
}) => {
  const lines = [];
  children.split(/\n/).forEach((entry) => {
    lines.push(
      ...(noLinkDetection ? [entry] : getLinks(entry, { linkClassName })),
      <br />,
    );
  });
  return createElement(as, rest, ...lines.slice(0, -1));
};

export default TextWithNewlines;
